<template>
  <div class="app-main-content price-fcl">
    <div
      v-show="showMainList"
      class="main-content"
      type="primary"
    >
      <fcl-search-bar
        ref="searchBar"
        :is-show-sale-state="true"
        :is-query-price="true"
        :show-currency="false"
        :is-manage-module="true"
        :is-show-contract-no="true"
        :filter="filter"
        :is-cp="activeTabName === 'cpList'"
        config-id="PriceFCL"
        :disabled-freight-type="!isCp"
        @onLevelChanged="onLevelChanged"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemResetCallBack="toAdvancedQuery"
        @reset="resetQuery"
      >
        <template v-if="activeTabName === 'cpList'" slot="operations">
          <el-button v-show="inputAllowed_PP" no="onEditCP2" type="success" :disabled="!this.cpSelectRow" @click="onEdit_CP()">{{ $t('Pricing.Edit') }}</el-button>
          <el-button v-show="deleteAllowed_CP" no="onDeleteCP2" type="primary" @click="onDelete_CP()">{{ $t('Pricing.Invalid') }}</el-button>
          <el-button v-show="deleteAllowed_CP" no="onPriceStateCP2" type="primary" @click="onPriceState_CP(0)">{{ $t('Pricing.PriceState_Common') }}</el-button>
          <el-button v-show="deleteAllowed_CP" no="onPriceStateCP2" type="primary" @click="onPriceState_CP(1)">{{ $t('Pricing.PriceState_Suspend') }}</el-button>
          <el-button v-show="deleteAllowed_CP" no="onPriceStateCP2" type="primary" @click="onPriceState_CP(2)">{{ $t('Pricing.PriceState_Reject') }}</el-button>
          <el-button v-show="deleteAllowed_CP" no="onPriceStateCP2" type="primary" @click="onPriceState_CP(3)">{{ $t('Pricing.PriceState_Inquiry') }}</el-button>
          <el-button v-show="deleteAllowed_CP" no="onPriceStateCP2" type="primary" @click="onPriceState_CP(4)">{{ $t('Pricing.PriceState_Lack') }}</el-button>
          <el-button v-show="deleteAllowed_CP" no="onPriceStateCP2" type="primary" @click="onPriceState_CP(5)">{{ $t('Pricing.PriceState_Overbooked') }}</el-button>
          <el-button v-show="deleteAllowed_CP" no="onDownloadTemplateRelease2" type="primary" @click="onDownloadTemplateRelease()">{{ $t('Pricing.Template') }}</el-button>
          <el-upload
            v-show="deleteAllowed_CP"
            no="saveExcelFile2"
            :action="URL.price.saveExcelFile"
            :headers="{sessionId}"
            :show-file-list="false"
            accept=".xls, .xlsx"
            :before-upload="beforeUpload"
            :on-success="uploadExcelSuccess"
            :data="{isRelease:true, branchId}"
            :on-progress="uploadProcess"
            style="display: inline-block; margin-left: 5px"
          >
            <el-button no="onImportFileRelease" type="primary" @click="onImportFileRelease()">{{ $t('Pricing.Import') }}</el-button>
          </el-upload>
        </template>
        <template v-if="activeTabName !== 'cpList'" slot="operations">
          <el-button v-show="inputAllowed_PP" no="onEditCP" type="success" :disabled="!this.ppSelectRow && !spotPpSelectRow" @click="onEdit_PP()">{{ $t('Pricing.Edit') }}</el-button>
          <el-button no="onDeletePP" type="danger" :disabled="!this.selectedPpCount && !this.selectedSpotPpCount" @click="onDelete_PP()">{{ $t('Pricing.Delete') }}</el-button>
          <el-button v-show="approveAllowed_PP" no="onApprovePP2" :disabled="!this.selectedPpCount && !this.selectedSpotPpCount" type="primary" @click="onApprove_PP2()">{{ $t('Pricing.SchemeAudit') }}</el-button>
          <el-button v-show="approveAllowed_PP" no="onApprovePP" :disabled="!this.selectedPpCount && !this.selectedSpotPpCount" type="primary" @click="onApprove_PP()">{{ $t('Pricing.ManualAudit') }}</el-button>
          <el-button v-show="priceFclUtil.isApprove" no="onConfigPriceFcl" type="primary" @click="onConfigPriceFcl()">{{ $t('Pricing.Setting') }}</el-button>
          <el-button v-show="inputAllowed_PP" no="onAddPP" type="primary" @click="onAdd_PP()">{{ $t('Pricing.Add') }}</el-button>
          <el-button v-show="inputAllowed_PP" no="onDownloadTemplate" type="primary" @click="onDownloadTemplate()">{{ $t('Pricing.Template') }}</el-button>
          <el-upload
            v-show="inputAllowed_PP"
            no="saveExcelFile"
            :action="URL.price.saveExcelFile"
            :headers="{sessionId}"
            :show-file-list="false"
            accept=".xls, .xlsx"
            :before-upload="beforeUpload"
            :on-success="uploadExcelSuccess"
            :on-error="uploadExcelError"
            :data="{isRelease:false, branchId}"
            :on-progress="uploadProcess"
            style="display: inline-block; margin-left: 5px"
          >
            <el-button no="onImportFilePP" type="primary" @click="onImportFile_PP()">{{ $t('Pricing.Import') }}</el-button>
          </el-upload>
          <el-upload
            v-show="inputAllowed_PP && activeTabName === 'spotPpList'"
            no="saveExcelFile"
            :action="URL.price.saveGeekYumExcelFile"
            :headers="{sessionId}"
            :show-file-list="false"
            accept=".xls, .xlsx"
            :on-success="uploadGeekYumExcelSuccess"
            :on-error="uploadExcelError"
            :data="{isRelease:false, branchId}"
            :on-progress="uploadProcess"
            style="display: inline-block; margin-left: 5px"
          >
            <el-button no="onGeekYumImportFilePP" type="primary" @click="onImportFile_PP()">{{ $t('Pricing.GeekYumImport') }}</el-button>
          </el-upload>
          <!-- 导入壹沓运价-->
          <el-upload
            v-show="inputAllowed_PP && activeTabName === 'spotPpList'"
            no="oneStackExcelFile"
            :action="URL.price.saveOneStackExcelFile"
            :headers="{sessionId}"
            :show-file-list="false"
            accept=".xls, .xlsx"
            :on-success="uploadGeekYumExcelSuccess"
            :on-error="uploadExcelError"
            :data="{isRelease:false, branchId}"
            :on-progress="uploadProcess"
            style="display: inline-block; margin-left: 5px"
          >
            <el-button no="oneStackExcelFilePP" type="primary" @click="onImportFile_PP()">{{ $t('Pricing.OneStackImport') }}</el-button>
          </el-upload>
        </template>
      </fcl-search-bar>
    </div>
    <div class="tabs-container">
      <el-tabs
        ref="tabs"
        v-model="activeTabName"
        type="card"
        style="width:100%;"
        @tab-click="handleTabClick"
      >
        <el-tab-pane :label="$t('Pricing.CurrentPrice')" name="cpList">
          <fcl-data-grid
            :v-if="activeTabName === 'cpList'"
            config-module="221301"
            :row-data="rowCpData"
            :show-price-no="true"
            :show-approve="true"
            :filter="filter"
            :grid-options="cpGridOptions"
            :view="1"
            @selectRowChange="selectRowChange"
          />
        </el-tab-pane>
        <el-tab-pane :label="$t('Pricing.TraditionalFreightRates') + $t('Pricing.PendingPrice')" name="ppList">
          <fcl-data-grid
            :v-if="activeTabName === 'ppList'"
            config-module="221302"
            :row-data="rowPpData"
            :show-price-no="false"
            :show-approve="false"
            :filter="filter"
            :grid-options="ppGridOptions"
            :view="0"
            @selectRowChange="selectRowChange"
          />
        </el-tab-pane>
        <el-tab-pane :label="$t('Pricing.SpotFreightRates') + $t('Pricing.PendingPrice')" name="spotPpList">
          <fcl-data-grid
            :v-if="activeTabName === 'spotPpList'"
            config-module="221303"
            :row-data="rowSpotPpData"
            :show-price-no="false"
            :show-approve="false"
            :filter="filter"
            :grid-options="spotPpGridOptions"
            :view="0"
            @selectRowChange="selectRowChange"
          />
        </el-tab-pane>
      </el-tabs>
      <div style="position: absolute; left: 270px;margin: 10px;">
        <span>{{ globalMsg }}</span>
      </div>
    </div>
    <fcl-form
      v-if="fclFormDialog.visible"
      :visible="fclFormDialog.visible"
      :source-price="fclFormDialog.sourcePrice"
      :price="fclFormDialog.price"
      :is-new="fclFormDialog.isNew"
      :is-cp="activeTabName === 'cpList'"
      :disabled-freight-type="!isCp"
      @close="onFclFormDialogClose"
      @deleteCp="deleteCp"
      @reload="toQuery"
      @clearGrid="clearGrid"
    />
    <el-dialog
      v-el-drag-dialog
      :visible.sync="priceStateRejectDialog.visible"
      :title="this.$t('Pricing.PriceState_Reject')"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <div style="width: 100%;">
        <div style="margin: 10px;color: blue;"><span>{{ $t('Pricing.PlsSelectRejectEQ') }}</span></div>
        <div style="text-align: center;">
          <el-checkbox v-model="priceStateRejectDialog.price.reject20" no="reject20" label="20'" />
          <el-checkbox v-model="priceStateRejectDialog.price.reject40" no="reject40" label="40'" />
          <el-checkbox v-model="priceStateRejectDialog.price.rejectHC" no="rejectHC" label="40'HC" />
          <el-checkbox v-model="priceStateRejectDialog.price.reject45" no="reject45" label="45'" />
        </div>
      </div>
      <span slot="footer">
        <el-button
          no="confirm"
          type="primary"
          @click="rejectOk"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="cancel"
          @click="priceStateRejectDialog.visible=false"
        >{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <fcl-markup-scheme-dialog
      ref="schemeDialog"
      :visible="fclMarkupSchemeDialog.visible"
      :selected-rows="fclMarkupSchemeDialog.selectedRows"
      :is-spot="activeTabName === 'spotPpList'"
      @close="onFclMarkupSchemeDialogClose"
      @auditBack="auditBack"
    />
    <fcl-markup-manual-dialog
      ref="manualDialog"
      :visible="fclMarkupManualDialog.visible"
      :is-spot="activeTabName === 'spotPpList'"
      @close="onFclMarkupManualDialogClose"
      @auditBack="auditBack"
    />
    <fcl-settings-dialog
      ref="settingsDialog"
      :visible="fclSettingsDialog.visible"
      @close="onFclSettingsDialogClose"
    />
  </div>
</template>

<script>

import FclSearchBar from '@/views/cargo/v0/Price/components/query/fclSearchBar'
import { getLoading } from '@/utils/utilBaseElement'
import { queryPendingPriceFcl,
  queryEffectivePriceFcl,
  inactivePriceFcls,
  updatePriceStateOfPriceFcls,
  deletePriceFcls,
  rejectPriceFcls,
  approvePriceFcls,
  checkPodFromExcel } from '@/api/price/priceFcl'
import fclDataGrid from '@/views/cargo/v0/Price/components/grid/fclDataGrid'
import DateUtils from '@/utils/dateUtils'
import FclForm from '@/views/cargo/v0/Price/PriceFCL/components/PriceFCL/fclForm'
import { MultiCompanyUtil } from '@/class/cargo/model/utils/MultiCompanyUtil'
import { PricingFCLConfigUtil } from '@/class/cargo/model/utils/PricingFCLConfigUtil'
import { PriceFCLValidityUtil } from '@/class/cargo/model/utils/PriceFCLValidityUtil'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import StrUtils from '@/utils/StrUtils'
import FclMarkupSchemeDialog from '@/views/cargo/v0/Price/PriceFCL/components/PriceFCL/fclMarkupSchemeDialog'
import FclSettingsDialog from '@/views/cargo/v0/Price/PriceFCL/components/PriceFCL/fclSettingsDialog'
import FclMarkupManualDialog from '@/views/cargo/v0/Price/PriceFCL/components/PriceFCL/fclMarkupManualDialog'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import URL from '@/api/urlTranslator'
import { PriceUploadExceptionUtil } from '@/class/cargo/model/utils/PriceUploadExceptionUtil'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { deepClone } from '@/utils'

export default {
  name: 'PriceFCL',
  components: {
    FclMarkupManualDialog,
    FclMarkupSchemeDialog,
    FclSettingsDialog,
    FclForm, FclSearchBar, fclDataGrid },
  data() {
    return {
      URL,
      activeTabName: 'cpList',
      globalMsg: '', // 查询条数和勾选条数显示
      isHQManager: false,
      remarkChange: '',
      targetLevel: 0,
      txtRemarks: '',
      showDetail: false,
      fullscreenLoading: null,
      proxy: {},
      filter: {
        total: 0,
        pol: '',
        pols: '',
        pods: '',
        pod: '',
        cod: '',
        col: '',
        rod: '',
        rol: '',
        carrier: [],
        region: '',
        polCityCode: '',
        podCityCode: '',
        cmbCreatedBy: 'createdBy',
        createdBy: 0,
        branch: 0,
        saleState: -1,
        txtBookingAgent: '',
        unNo: '',
        contractNo: '',
        level: '',
        currency: 'USD',
        beginDate: null,
        endDate: '',
        createDateFrom: DateUtils.formatStandardDate(new Date()),
        dangerous: false,
        isAddon: false,
        direct: false,
        frequency1: false,
        frequency2: false,
        frequency3: false,
        frequency4: false,
        frequency5: false,
        frequency6: false,
        frequency7: false,
        cost20nor: 0,
        vessel: '',
        voyageFlight: '',
        beginEtd: null,
        endEtd: null,
        beginEta: null,
        endEta: null,
        freightType: null
      },
      selectedPpCount: 0,
      selectedSpotPpCount: 0,
      rowCpData: [],
      rowPpData: [],
      rowSpotPpData: [],
      cpGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onSelectionChanged: event => {
          const rows = event.api.getSelectedRows()
          this.globalMsg = rows.length > 0 ? StrUtils.substitute(this.$t('Pricing.selectedCount'), rows.length) : ''
        }
      },
      ppGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onSelectionChanged: event => {
          const rows = event.api.getSelectedRows()
          this.selectedPpCount = rows.length
          this.globalMsg = rows.length > 0 ? StrUtils.substitute(this.$t('Pricing.selectedCount'), rows.length) : ''
        }
      },
      spotPpGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onSelectionChanged: event => {
          const rows = event.api.getSelectedRows()
          this.selectedSpotPpCount = rows.length
          this.globalMsg = rows.length > 0 ? StrUtils.substitute(this.$t('Pricing.selectedCount'), rows.length) : ''
        }
      },
      fclFormDialog: {
        visible: false,
        price: {},
        sourcePrice: {},
        isNew: false
      },
      priceStateRejectDialog: {
        visible: false,
        price: {
          reject20: false,
          reject40: false,
          rejectHC: false,
          reject45: false,
          priceFclUuids: []
        }
      },
      fclMarkupSchemeDialog: {
        visible: false,
        selectedRows: []
      },
      fclMarkupManualDialog: {
        visible: false,
        selectedRows: []
      },
      fclSettingsDialog: {
        visible: false
      },
      cpSelectRow: null, // 已发布的单击选择行
      ppSelectRow: null, // 待审核的单击选择行
      spotPpSelectRow: null, // 待审核的单击选择行
      approveAllowed_PP: false,
      deleteAllowed_PP: false,
      deleteAllowed_CP: false,
      inputAllowed_PP: false,
      priceFclUtil: null
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    },
    sessionId() {
      return this.$store.getters.token
    },
    branchId() {
      return this.$store.getters.currentOfficeId
    },
    isCp() {
      return this.activeTabName === 'cpList'
    },
    localConfigId() {
      return 'PriceFCL' + this.$store.getters.userId
    }
  },
  watch: {
    '$store.getters.currentOfficeId': function() {
    },
    activeTabName(val) {
      LocalStorageUtils.setConfiguration('PriceFCL', val)
      const proxy = LocalStorageUtils.getConfiguration(this.localConfigId)
      if (proxy) {
        if (this.activeTabName === 'ppList') {
          proxy.freightType = 0
          LocalStorageUtils.setConfiguration(this.localConfigId, proxy)
        } else if (this.activeTabName === 'spotPpList') {
          proxy.freightType = 1
          LocalStorageUtils.setConfiguration(this.localConfigId, proxy)
        }
      }
    }
  },
  beforeMount() {
    this.init()
  },
  methods: {
    async init() {
      const activeTab = LocalStorageUtils.getConfiguration('PriceFCL')
      this.activeTabName = !StrUtils.isEmpty(activeTab) ? activeTab : 'ppList'
      this.isHQManager = MultiCompanyUtil.getInstance().isHQManager('PriceFcl')
      this.priceFclUtil = await PricingFCLConfigUtil.getInstance()
      if (this.$store.getters.isAdmin) {
        this.approveAllowed_PP = true
        this.deleteAllowed_PP = true
        this.deleteAllowed_CP = true
        this.inputAllowed_PP = true
      } else {
        // 改成有批准权限人，就能删除
        this.approveAllowed_PP = this.deleteAllowed_CP = this.deleteAllowed_PP = this.priceFclUtil.isApprove
        this.inputAllowed_PP = this.priceFclUtil.isInput
      }
      this.filter.freightType = this.isCp ? null : (this.activeTabName === 'ppList' ? 0 : 1)
    },
    // tab 页签点击事件
    handleTabClick(tab, event) {
      this.activeTabName = tab.name
      this.filter.freightType = this.isCp ? null : (this.activeTabName === 'ppList' ? 0 : 1)
      this.$refs['searchBar'].updateLevel(this.activeTabName === 'cpList')
    },
    onLevelChanged(searchLevel) {
      if (this.activeTabName === 'cpList') {
        this.targetLevel = searchLevel.level
      }
      this.clearGrid()
    },
    toAdvancedQuery(data) {
      this.proxy = data
      this.toQuery()
    },
    // 查询
    toSimpleQuery(proxy) {
      this.proxy = proxy
      this.toQuery()
    },
    onFclFormDialogClose() {
      this.fclFormDialog.visible = false
      this.fclFormDialog.data = {}
    },
    onFclMarkupSchemeDialogClose() {
      this.fclMarkupSchemeDialog.visible = false
      this.fclMarkupSchemeDialog.rowData = {}
    },
    onFclMarkupManualDialogClose() {
      this.fclMarkupManualDialog.visible = false
    },
    onFclSettingsDialogClose() {
      this.fclSettingsDialog.visible = false
    },
    toQuery() {
      this.fullscreenLoading = getLoading()
      if (this.activeTabName === 'cpList') {
        queryEffectivePriceFcl(this.proxy).then((res) => {
          const _resMap = res.data
          this.fullscreenLoading.close()
          if (_resMap && _resMap.length === 0) {
            this.$message.warning(this.$t('Pricing.NoRecord'))
            this.rowCpData = []
            this.globalMsg = StrUtils.substitute(this.$t('Pricing.QueryRecords'), this.rowCpData.length)
          }
          const count = _resMap.length
          // 只返回部分结果的话，弹窗提醒是否加载更多
          if (PriceUtils.isReturnedPartOfResults(this.proxy.isLimited, count)) {
            const msg = StrUtils.substitute(this.$t('Pricing.MaxQueryCount2'), 300)
            this.$confirm(msg, this.$t('Pricing.Tips'), {
              confirmButtonText: this.$t('Pricing.YesLabel'),
              cancelButtonText: this.$t('Pricing.NoLabel'),
              type: 'info',
              closeOnClickModal: false,
              closeOnPressEscape: false,
              showClose: false
            }).then(() => {
            }).catch(() => {
              this.proxy.isLimited = false
              this.toQuery(this.proxy)
              return
            })
          }
          if (PriceUtils.isReturnedPartOfResults(this.proxy.isLimited, count)) {
            _resMap.pop()
          }
          this.rowCpData = _resMap
          this.globalMsg = StrUtils.substitute(this.$t('Pricing.QueryRecords'), this.rowCpData.length)
        }).catch(() => {
          this.fullscreenLoading.close()
        })
      } else {
        if (!MultiCompanyUtil.getInstance().isAdminOrHQ2('PriceFcl')) {
          this.proxy['branchId'] = this.$store.getters.currentOfficeId
        }
        queryPendingPriceFcl(this.proxy).then((res) => {
          if (this.activeTabName === 'ppList') {
            this.selectedPpCount = 0
          } else {
            this.selectedSpotPpCount = 0
          }
          const _resMap = res.data
          this.fullscreenLoading.close()
          if (_resMap && _resMap.length === 0) {
            this.$message.warning(this.$t('Pricing.NoRecord'))
            if (this.activeTabName === 'ppList') {
              this.rowPpData = []
            } else {
              this.rowSpotPpData = []
            }
            this.globalMsg = StrUtils.substitute(this.$t('Pricing.QueryRecords'), 0)
          }
          const count = _resMap.length
          // 只返回部分结果的话，弹窗提醒是否加载更多
          if (PriceUtils.isReturnedPartOfResults(this.proxy.isLimited, count)) {
            const msg = StrUtils.substitute(this.$t('Pricing.MaxQueryCount2'), 300)
            this.$confirm(msg, this.$t('Pricing.Tips'), {
              confirmButtonText: this.$t('Pricing.YesLabel'),
              cancelButtonText: this.$t('Pricing.NoLabel'),
              type: 'info',
              closeOnClickModal: false,
              closeOnPressEscape: false,
              showClose: false
            }).then(() => {
            }).catch(() => {
              this.proxy.isLimited = false
              this.toQuery(this.proxy)
              return
            })
          }
          if (PriceUtils.isReturnedPartOfResults(this.proxy.isLimited, count)) {
            _resMap.pop()
          }
          if (this.activeTabName === 'ppList') {
            this.rowPpData = _resMap
          } else {
            this.rowSpotPpData = _resMap
          }
          this.globalMsg = StrUtils.substitute(this.$t('Pricing.QueryRecords'), _resMap.length)
        }).catch(() => {
          this.fullscreenLoading.close()
        })
      }
    },
    onRowDoubleClicked(e) {
      const data = e.data
      if (this.activeTabName === 'cpList') {
        this.cpSelectRow = data
        this.onEdit_CP()
      } if (this.activeTabName === 'ppList') {
        this.ppSelectRow = data
        this.onEdit_PP()
      } else {
        this.spotPpSelectRow = data
        this.onEdit_PP()
      }
    },
    onEdit_CP() {
      if (!this.cpSelectRow) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return
      }
      if (!(Number(this.targetLevel) < 1)) {
        this.$message.warning(this.$t('Pricing.onlyViewAndEditCostAreAllow'))
        return
      }
      this.fclFormDialog.visible = true
      this.fclFormDialog.isNew = false
      this.fclFormDialog.sourcePrice = this.cpSelectRow
      const newPrice = deepClone(this.cpSelectRow)
      newPrice['uuid'] = ''
      newPrice['externalId'] = null
      newPrice['externalRefNo'] = null
      delete newPrice['dateCreated']
      this.fclFormDialog.price = newPrice
    },
    resetQuery() {
      if (this.activeTabName === 'cpList') {
        this.cpSelectRow = null
        this.rowCpData = []
      } if (this.activeTabName === 'ppList') {
        this.ppSelectRow = null
        this.selectedPpCount = 0
        this.rowPpData = []
      } else {
        this.spotPpSelectRow = null
        this.selectedSpotPpCount = 0
        this.rowSpotPpData = []
      }
      this.globalMsg = ''
    },
    onDelete_CP() {
      const selectedRows = this.getSelectedRowsCp()
      if (selectedRows === null) {
        return
      }
      this.$confirm(this.$t('Pricing.InvalidSelection'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const uuids = this.getSelectUuids(selectedRows)
        this.deleteCp(uuids, selectedRows)
      })
    },
    // 获取已发布的勾选数据
    getSelectedRowsCp() {
      const { api } = this.cpGridOptions
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return null
      }
      if (!this.isHQManager) {
        for (const item of selectedRows) {
          if (item.branchId !== this.$store.getters.currentOfficeId) {
            this.$message.warning(this.$t('Pricing.IsAllowedOperate_DiffBranch'))
            return null
          }
        }
      }
      return selectedRows
    },
    // 获取待审核的勾选数据
    getSelectedRowsPp() {
      const { api } = this.activeTabName === 'ppList' ? this.ppGridOptions : this.spotPpGridOptions
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return null
      }
      return selectedRows
    },
    // 修改已发布运价后, 移除原有记录
    deleteCp(data, selectedRows) {
      this.fullscreenLoading = getLoading()
      inactivePriceFcls({ priceFclUuids: data }).then(res => {
        this.$message.success(this.$t('Pricing.Finished'))
        // this.removeData(selectedRows)
        this.toQuery()
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    auditBack() {
      const { api } = this.activeTabName === 'ppList' ? this.ppGridOptions : this.spotPpGridOptions
      const selectedRows = api.getSelectedRows()
      this.removeData(selectedRows)
    },
    removeData(selectedRows) {
      if (selectedRows) {
        let api = null
        if (this.isCp) {
          this.cpSelectRow = null
          api = this.cpGridOptions.api
        } if (this.activeTabName === 'ppList') {
          this.selectedPpCount = 0
          this.ppSelectRow = null
          api = this.ppGridOptions.api
        } else {
          this.selectedSpotPpCount = 0
          this.spotPpSelectRow = null
          api = this.spotPpGridOptions.api
        }
        api.updateRowData({ 'remove': selectedRows })
      }
    },
    onPriceState_CP(state) {
      const selectedRows = this.getSelectedRowsCp()
      if (selectedRows === null) {
        return
      }
      const uuids = this.getSelectUuids(selectedRows)
      if (state === 2) { // 不接
        this.priceStateRejectDialog.visible = true
        this.priceStateRejectDialog.price.reject20 = false
        this.priceStateRejectDialog.price.reject40 = false
        this.priceStateRejectDialog.price.rejectHC = false
        this.priceStateRejectDialog.price.reject45 = false
        this.priceStateRejectDialog.price.priceFclUuids = uuids
        return
      }
      const stateName = CommonState.getNameByCode(PriceConstant.PRICE_STATE, state)
      const msg = this.$t('Pricing.SuspendSelection')
      this.$confirm(msg.replace('{0}', stateName), this.$t('Pricing.Tips'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = getLoading()
        updatePriceStateOfPriceFcls({ priceFclUuids: uuids, priceState: state }).then(res => {
          this.$message.success(this.$t('Pricing.Finished'))
          for (const item of selectedRows) {
            item.priceState = state
          }
          const api = this.getGridOptionsApi()
          api.clearFocusedCell()
          api.refreshCells({ force: true })
        }).finally(() => {
          this.fullscreenLoading.close()
        })
      })
    },
    onDownloadTemplateRelease() {
      ExportUtils.downloadTemplateFile('FinalFCL_sample.xls', 'price')
    },
    onImportFileRelease() {

    },
    getGridOptionsApi() {
      if (this.isCp) {
        return this.cpGridOptions.api
      }
      if (this.activeTabName === 'ppList') {
        return this.ppGridOptions.api
      }
      return this.spotPpGridOptions.api
    },
    onEdit_PP() {
      const data = this.activeTabName === 'ppList' ? this.ppSelectRow : this.spotPpSelectRow
      if (!data) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return
      }
      this.fclFormDialog.visible = true
      this.fclFormDialog.isNew = false
      this.fclFormDialog.price = deepClone(data)
      this.fclFormDialog.sourcePrice = data
    },
    onDelete_PP() {
      const selectedRows = this.getSelectedRowsPp()
      for (const item of selectedRows) {
        if (!(this.deleteAllowed_PP || item.createdBy === this.$store.getters.userInfo.userId)) {
          this.$message.warning(this.$t('Pricing.NotAllowedDelete'))
          return null
        }
      }
      if (selectedRows === null) {
        return
      }
      this.$confirm(this.$t('Pricing.IsDeleteRecords'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const uuids = this.getSelectUuids(selectedRows)
        this.fullscreenLoading = getLoading()
        deletePriceFcls({ priceFclUuids: uuids }).then(res => {
          this.$message.success(this.$t('Message.DeleteSuccessfully'))
          this.removeData(selectedRows)
        }).finally(() => {
          this.fullscreenLoading.close()
        })
      })
    },
    getSelectUuids(selectedRows) {
      const uuids = []
      selectedRows.forEach(item => {
        uuids.push(item.uuid)
      })
      return uuids
    },
    // 方案加价审核
    onApprove_PP2() {
      this.approve()
    },
    // 手工加价审核
    onApprove_PP() {
      const selectedRows = this.getSelectedRowsPp()
      if (selectedRows === null) return
      // 判断运价类型是否一致
      if (selectedRows.length !== 1) {
        const isConsistent = selectedRows.every(obj => obj.freightType === selectedRows[0].freightType)
        if (!isConsistent) {
          this.$message.warning(this.$t('Pricing.PleaseSelectDataForTheSameTariffType'))
          return
        }
      }
      if (!this.priceFclUtil._needMarkup) {
        this.fullscreenLoading = getLoading()
        approvePriceFcls(selectedRows).then(res => {
          this.$message.success(this.$t('Pricing.ManualAudit') + this.$t('Message.Success'))
          this.removeData(selectedRows)
        }).finally(() => {
          this.fullscreenLoading.close()
        })
        return
      }
      this.fclMarkupManualDialog.visible = true
      const uuids = this.getSelectUuids(selectedRows)
      this.$refs['manualDialog'].setData(uuids, selectedRows)
    },
    onConfigPriceFcl() {
      this.fclSettingsDialog.visible = true
      this.$nextTick(() => {
        this.$refs['settingsDialog'].init(this.priceFclUtil)
      })
    },
    onAdd_PP() {
      this.fclFormDialog.visible = true
      this.fclFormDialog.isNew = true
      this.fclFormDialog.price = {
        state: 0,
        active: false,
        direct: true,
        term: 'P',
        currency: 'USD',
        eqType: 'GP',
        days: 0,
        freeTime: 0,
        share: 'SELF',
        saleState: 0,
        priceState: 0,
        serviceMode: ' ',
        trend: 0,
        dateTypeEffective: 1,
        dateTypeExpiration: 1,
        closingDay: '',
        cost20: 0,
        cost40: 0,
        costhc: 0,
        cost45: 0,
        sellVat: 0,
        costVat: 0,
        cargoType: 'GC',
        cost20nor: 0,
        vessel: '',
        voyageFlight: '',
        etd: null,
        eta: null,
        freightType: this.activeTabName === 'ppList' ? 0 : 1
      }
    },
    onDownloadTemplate() {
      ExportUtils.downloadTemplateFile('FCL_sample.xls', 'price')
    },
    onImportFile_PP() {},
    selectRowChange(data) {
      if (this.activeTabName === 'cpList') {
        this.cpSelectRow = data
      } if (this.activeTabName === 'ppList') {
        this.ppSelectRow = data
      } else {
        this.spotPpSelectRow = data
      }
    },
    rejectOk() {
      this.fullscreenLoading = getLoading()
      rejectPriceFcls(this.priceStateRejectDialog.price).then(res => {
        this.$message.success(this.$t('Pricing.Finished'))
        this.priceStateRejectDialog.visible = false
        this.toQuery()
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    approve() {
      const selectedRows = this.getSelectedRowsPp()
      if (selectedRows === null) return
      // 判断运价类型是否一致
      if (selectedRows.length !== 1) {
        const isConsistent = selectedRows.every(obj => obj.freightType === selectedRows[0].freightType)
        if (!isConsistent) {
          this.$message.warning(this.$t('Pricing.PleaseSelectDataForTheSameTariffType'))
          return
        }
      }
      if (!this.isAllowedApprove(selectedRows)) return
      if (this.priceFclUtil._needCheckValidity && !PriceFCLValidityUtil.getInstance().isValid(selectedRows)) {
        if (this.priceFclUtil._PFValiditySetting === null) {
          this.$message.error(this.$t('Pricing.ValidityCfgLoadError'))
          return false
        }
      }
      this.fclMarkupSchemeDialog.visible = true
      this.fclMarkupSchemeDialog.selectedRows = selectedRows
      this.$nextTick(() => {
        this.$refs['schemeDialog'].init(this.priceFclUtil)
      })
    },
    isAllowedApprove(selectedRows) {
      if (!this.$store.getters.isAdmin) {
        const officeIds = MultiCompanyUtil.getInstance().getOfficeIDsForApprove('PriceFcl')
        if (!officeIds || officeIds === null || officeIds.length === 0) {
          return false
        }
        if (officeIds[0] === 0) {
          const ofcIDMap = {}
          for (let i = officeIds.length - 1; i >= 1; i--) {
            ofcIDMap[officeIds[i]] = i // ofcIDs中可能存在重复的id，但不影响
          }
          for (const item of selectedRows) {
            if (!ofcIDMap.hasOwnProperty(item.branchId)) {
              this.$confirm(StrUtils.substitute(this.$t('Pricing.IsAllowedOperate'), item.pol, item.pod), this.$t('Message.Prompt'), {
                confirmButtonText: this.$t('common.btn.ok'),
                cancelButtonText: this.$t('common.btn.cancel'),
                type: 'warning'
              }).then(() => {
                // 定位到该列
              })
              return false
            }
          }
        }
      }
      return true
    },
    onTxtRemarksDoubleClick() {
      this.$nextTick(() => {
        this.$refs.txtRemark.style.height = !this.remarkChange ? '30%' : '6%'
        this.remarkChange = !this.remarkChange
      })
    },
    beforeUpload(file) {
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
        return false
      }
      return new Promise((resolve, reject) => {
        this.checkExcel(file).then(result => {
          if (result === '') {
            resolve()
            return
          }
          if (result === 'rodErr') {
            this.$message.warning(this.$t('Price.DestinationAreaError'))
            reject()
          } else {
            const msg = result.replace(/\n/g, '<br/>')
            this.$confirm(msg + this.$t('Price.ContinueImporting'), this.$t('Message.Prompt'), {
              dangerouslyUseHTMLString: true,
              confirmButtonText: this.$t('common.btn.ok'),
              cancelButtonText: this.$t('common.btn.cancel'),
              type: 'warning'
            }).then(() => {
              resolve()
              // 定位到该列
            }).catch(() => {
              reject()
            })
          }
        })
      })
    },
    async checkExcel(file) {
      let result = ''
      await checkPodFromExcel(file).then(res => {
        result = res.data
      })
      return result
    },
    uploadExcelSuccess(response, file, fileList) {
      this.fullscreenLoading.close()
      if (response && response.data) {
        this.onImportSucceeded(JSON.parse(response.data))
      } else {
        this.$message.error(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    uploadGeekYumExcelSuccess(response, file, fileList) {
      this.fullscreenLoading.close()
      if (response && response.data) {
        this.onGeekYumImportSucceeded(JSON.parse(response.data))
      } else {
        this.$message.error(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    uploadExcelError(err) {
      this.fullscreenLoading.close()
      console.log(err)
    },
    onGeekYumImportSucceeded(message) {
      if (message.success) {
        const result = message.resultMessage
        const records = result.split(',')
        let msg = ''
        if (records.length > 1) {
          for (const sheet of records) {
            if (StrUtils.isEmpty(sheet)) {
              continue
            }
            const tmp = sheet.split(':')
            msg += StrUtils.substitute(this.$t('Pricing.Records'), tmp) + '\n'
          }
          msg += this.$t('Pricing.LoadSucceed')
          this.$message.success(msg)
        } else {
          if (result === '') {
            this.$message.error(this.$t('Pricing.NoRecordUpload'))
          } else {
            const tmp = result.split(':')
            msg = StrUtils.substitute(this.$t('Pricing.Records'), tmp)
            msg = msg.substr(0, msg.length - 1) + this.$t('Pricing.LoadSucceed')
            this.$message.success(msg)
          }
        }
        return
      }
      this.$confirm(message.errorMessage, this.$t('Message.Error2'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('common.btn.ok'),
        type: 'error'
      }).then(() => {
        // 定位到该列
      }).catch(() => {
      })
    },
    onImportSucceeded(message) {
      if (message.success) {
        const result = message.resultMessage
        const records = result.split(',')
        let msg = ''
        if (records.length > 1) {
          for (const sheet of records) {
            if (StrUtils.isEmpty(sheet)) {
              continue
            }
            const tmp = sheet.split(':')
            msg += StrUtils.substitute(this.$t('Pricing.Records'), tmp) + '\n'
          }
          msg += this.$t('Pricing.LoadSucceed')
          this.$message.success(msg)
        } else {
          if (result === '') {
            this.$message.error(this.$t('Pricing.NoRecordUpload'))
          } else {
            const tmp = result.split(':')
            msg = StrUtils.substitute(this.$t('Pricing.Records'), tmp)
            msg = msg.substr(0, msg.length - 1) + this.$t('Pricing.LoadSucceed')
            this.$message.success(msg)
          }
        }
        return
      }
      // 导入失败
      const failResult = PriceUploadExceptionUtil.handleError(message)
      this.$confirm(failResult.replace(/\n\t/g, '<br/>'), this.$t('Message.Error2'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('common.btn.ok'),
        type: 'error'
      }).then(() => {
        // 定位到该列
      }).catch(() => {
      })
    },
    uploadProcess() {
      this.fullscreenLoading = getLoading('price-fcl')
    },
    clearGrid() {
      const api = this.getGridOptionsApi()
      api.clearFocusedCell()
      api.refreshCells({ force: true })
    }
  }
}
</script>

<style lang="scss">
  .el-message-box__message{
    max-height: 400px;
    p{
      max-height: 380px;
      overflow: auto;
    }
  }
</style>
